import React from 'react';

import FeatureToggle from '../feature-toggle/feature-toggle';
import { IntegrationSlot } from './integrations-list/integration-slot';
import { TEXTS } from './integrations.constants';
import { IntegrationDefinition, ModalIntegrationProps } from './integration-strategies/modal-strategy/modal-strategy.types';
import { OAuthStrategyOptions } from './integration-strategies/oauth-strategy/oauth-strategy.types';

export const createFeatureToggleStrategyIntegration = (
    props: ModalIntegrationProps|OAuthStrategyOptions, strategyCreateFunction,
): IntegrationDefinition => {
    const { testId, feature } = props;
    const { id, Component } = strategyCreateFunction(props);
    return ({
        id,
        Component: componentProps => (
            <FeatureToggle
                feature={feature}
                target={() => <Component {...props} {...componentProps} />}
                replacement={() => (
                    <IntegrationSlot
                        {...props}
                        isDisabled
                        isIntegrated={false}
                        subtitle={TEXTS.UPGRADE_PLAN}
                        onClick={() => {}}
                        testId={testId}
                    />
                )}
            />
        ),
    });
};
